import { refreshMyDosespotClinicianInfo } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type { DoseSpotClinicianInfoT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

/**
 * Refresh DoseSpot clinician information for the authenticated user.
 * This fetches the latest data from DoseSpot and updates the local record.
 */
export async function fetchRefreshMyDosespotClinicianInfo(
  signal?: AbortSignal
): Promise<DoseSpotClinicianInfoT> {
  const config = await createLotusRequestConfig({ signal });
  const response = await refreshMyDosespotClinicianInfo(config);
  return lotusHealthZod.refreshMyDosespotClinicianInfoResponse.parse(
    response.data
  ) as DoseSpotClinicianInfoT;
}
